let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("gpyq7")]).then(() => parcelRequire('3f9CL'));